import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Fir5471ScheduleIService {

  constructor(private http: HttpClient) { }

  saveScheduleI(
    baseUrl: string,
    scheduleSettings: any[],
    scheduleDetails: any,
    globalParams: any = {},
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=dsbcjk`;

    let params = _.merge({}, globalParams, filterParams);
    params = _.extend({
      jsonObj: JSON.stringify(scheduleDetails),
      jsonSettings: JSON.stringify(scheduleSettings),
      process_name: 'Schedule_I_Save',
      is_issue_key_enabled: globalParams?.is_issue_key_enabled,
      scenarioCode: globalParams?.scenarioCode
    }, params);

    const formData = new FormData();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        formData.append(key, params[key].toString());
      }
    });

    const options = {
      withCredentials: true
    };

    return this.http.post<any>(url, formData, options);
  }

  updateFlag(
    baseUrl: string,
    jsonSettings: any[],
    jsonDetails: any[],
    globalParams: any = {},
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=1tfdq7`;

    let params = _.merge({}, globalParams, filterParams);
    params = _.extend({
      jsonObj: JSON.stringify(jsonDetails),
      jsonSettings: JSON.stringify(jsonSettings),
      process_name: 'Schedule_I_updateFlag',
      is_issue_key_enabled: globalParams?.is_issue_key_enabled,
      scenarioCode: globalParams?.scenarioCode
    }, params);

    const formData = new FormData();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        formData.append(key, params[key].toString());
      }
    });

    const options = {
      withCredentials: true
    };

    return this.http.post<any>(url, formData, options);
  }
}
